import { NavLink, ThemeIcon } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

/** One destination: the glyph in a 30px light tile, gray until active, then brand tile and brand-soft row. Hover stays neutral. */
export const NavItem = ({
    to,
    label,
    icon: Glyph,
    active,
}: {
    to: string;
    label: string;
    icon: Icon;
    active: boolean;
}) => (
    <NavLink
        component={Link}
        to={to}
        label={label}
        active={active}
        variant="light"
        aria-current={active ? 'page' : undefined}
        leftSection={
            <ThemeIcon variant="light" size={30} color={active ? 'rgsOrange' : 'gray'}>
                <Glyph size={18} stroke={1.7} />
            </ThemeIcon>
        }
        py={6}
        px="xs"
        styles={{ root: { borderRadius: 'var(--mantine-radius-md)' }, label: { fontWeight: 500 } }}
    />
);
